import React from "react";

interface IconProps {
  className?: string;
  size?: number;
}

/**
 * Creators Choice Icon - Person silhouette with concentric arcs wrapping around
 * Like the Apple Podcasts icon - represents curated content by a host
 */
export const CreatorsIcon: React.FC<IconProps> = ({
  className = "",
  size = 20,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Outer circular arc - wraps around */}
    <path
      d="M3 12 A9 9 0 1 1 21 12 A9 9 0 0 1 18 18"
      fill="none"
      strokeWidth="2"
    />

    {/* Inner circular arc */}
    <path
      d="M6 12 A6 6 0 1 1 18 12 A6 6 0 0 1 16 16"
      fill="none"
      strokeWidth="2"
    />

    {/* Person head - centered circle */}
    <circle cx="12" cy="10" r="2" fill="currentColor" stroke="none" />

    {/* Person body - small rounded shape */}
    <path
      d="M9 20 L10 15 C10 14 11 13 12 13 C13 13 14 14 14 15 L15 20"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);

/**
 * Radio Icon - Classic vintage radio with antenna, dial and speaker
 */
export const ClassicRadioIcon: React.FC<IconProps> = ({
  className = "",
  size = 20,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Antenna */}
    <line x1="5" y1="2" x2="10" y2="7" />

    {/* Radio body - rounded rectangle */}
    <rect x="3" y="7" width="18" height="13" rx="2" />

    {/* Speaker circle - left side */}
    <circle cx="8" cy="13.5" r="3.5" />

    {/* Dial lines - right side */}
    <line x1="14" y1="10" x2="19" y2="10" />
    <line x1="14" y1="12.5" x2="19" y2="12.5" />
    <line x1="14" y1="15" x2="19" y2="15" />
    <line x1="14" y1="17.5" x2="19" y2="17.5" />
  </svg>
);

/**
 * Podcast Icon - Classic microphone with horizontal lines (studio mic style)
 */
export const PodcastMicIcon: React.FC<IconProps> = ({
  className = "",
  size = 20,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Mic head - rounded top */}
    <path
      d="M12 2 C8 2 6 5 6 8 L6 10 C6 13 8 15 12 15 C16 15 18 13 18 10 L18 8 C18 5 16 2 12 2"
      fill="currentColor"
      stroke="none"
    />

    {/* Mic stand curve (U shape) */}
    <path d="M5 11 C5 16 8 18 12 18 C16 18 19 16 19 11" fill="none" />

    {/* Mic stand vertical */}
    <line x1="12" y1="18" x2="12" y2="22" />

    {/* Mic base */}
    <line x1="8" y1="22" x2="16" y2="22" />

    {/* Horizontal lines on mic head */}
    <line
      x1="7"
      y1="6"
      x2="17"
      y2="6"
      stroke="var(--bg-card, #0a0a0a)"
      strokeWidth="1.2"
    />
    <line
      x1="7"
      y1="8.5"
      x2="17"
      y2="8.5"
      stroke="var(--bg-card, #0a0a0a)"
      strokeWidth="1.2"
    />
    <line
      x1="7"
      y1="11"
      x2="17"
      y2="11"
      stroke="var(--bg-card, #0a0a0a)"
      strokeWidth="1.2"
    />
  </svg>
);

export default { CreatorsIcon, ClassicRadioIcon, PodcastMicIcon };
